import IEventBinding from '../Interfaces/IEventBinding';

const handler = (): void => {
    const hasFullscreenElement = Boolean(
        document.webkitFullscreenElement ||
        (document as any).mozFullScreenElement ||
        document.fullscreenElement
    );

    if (hasFullscreenElement) return;

    const ev = new CustomEvent('exitfullscreen', {
        bubbles: true
    });

    document.dispatchEvent(ev);
};

const createExitFullscreenEvent = (): IEventBinding => {
    window.addEventListener('webkitfullscreenchange', handler);
    window.addEventListener('mozfullscreenchange', handler);
    window.addEventListener('MSFullscreenchange', handler);
    window.addEventListener('fullscreenchange', handler);

    const release = (): void => {
        window.removeEventListener('webkitfullscreenchange', handler);
        window.removeEventListener('mozfullscreenchange', handler);
        window.removeEventListener('MSFullscreenchange', handler);
        window.removeEventListener('fullscreenchange', handler);
    };

    return {
        release
    };
};

export default createExitFullscreenEvent;